import React, { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { AllParams, ParamsNames } from "../../modules/router/constantes/paramsNames";
import { AnnotationsList } from "../../modules/annotation/components/annotations-list.component";

export const SiteAnnotationsPage: FunctionComponent = () => {
  const params = useParams<Pick<AllParams, ParamsNames.SITE_ID>>();

  return <AnnotationsList siteId={params.siteId} />;
}; 
